export default "__VITE_ASSET__b18ecbeb__"